import { render, staticRenderFns } from "./CustomerPortalStigg.vue?vue&type=template&id=0cfab90f&"
import script from "./CustomerPortalStigg.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalStigg.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPortalStigg.vue?vue&type=style&index=0&id=0cfab90f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports